import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Media from 'react-media';

import trackAction from 'utils/tracking';

import ActivityCard from 'components/ActivityCard';
import Carousel from 'components/Core/Carousel';

import { PopularActivityWrapper, PopularActivityTitle, PopularActivityCard } from './PopularActivity.styles';

const renderPopularActivitySlide = (item) => {
  if (item.page) {
    const { page: activity } = item;
    const activityData = activity.activity ? activity.activity : activity;
    const activityUrl = activity.url;
    return (
      <Link key={activityData.slug} href="/[...slug]" as={activityUrl} passHref>
        <PopularActivityCard
          className="block px-2 my-2 group flex-full max-w-full lg:flex-1/3 lg:max-w-1/3"
          onClick={() => trackAction('popular-activity', activityData.title, 'click')}
        >
          <ActivityCard {...{ ...activityData, url: activityUrl }} />
        </PopularActivityCard>
      </Link>
    );
  }
  return <div key="empty-activity" />;
};

const PopularActivity = ({ title, activities }) => {
  const PopularActivityDesktop = () => {
    return (
      <div className="flex flex-wrap -mx-4">
        {activities.map(({ page: activity }) => {
          // ActivityPage contains the activity data in the key `activity` and
          // CustomActivityPage doesn't.
          if (activity) {
            const activityData = activity.activity ? activity.activity : activity;
            const activityUrl = activity.url;
            return (
              <Link key={activityData.slug} href="/[...slug]" as={activityUrl} passHref>
                <PopularActivityCard
                  className="block px-4 my-2 group flex-full max-w-full lg:flex-1/3 lg:max-w-1/3"
                  onClick={() => trackAction('popular-activity', activityData.title, 'click')}
                >
                  <ActivityCard {...{ ...activityData, url: activityUrl }} />
                </PopularActivityCard>
              </Link>
            );
          }
          return <div key="empty-activity" />;
        })}
      </div>
    );
  };

  const mediaQueries = {
    md: '(min-width: 768px) and (max-width: 1023px)',
    lg: '(min-width: 1024px)',
  };

  return (
    <PopularActivityWrapper>
      <div className="container mx-auto px-4">
        <PopularActivityTitle>{title}</PopularActivityTitle>
        <Media queries={mediaQueries} defaultMatches={{ lg: true }}>
          {(matches) => {
            if (matches.lg) {
              return <PopularActivityDesktop />;
            }
            if (matches.md) {
              return <Carousel items={activities} visibleSlides={2} slideRenderer={renderPopularActivitySlide} />;
            }
            return <Carousel items={activities} slideRenderer={renderPopularActivitySlide} />;
          }}
        </Media>
      </div>
    </PopularActivityWrapper>
  );
};

PopularActivity.defaultProps = {
  title: 'Popular Activities',
  activities: [],
};

PopularActivity.propTypes = {
  title: PropTypes.string,
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      page: PropTypes.shape({}),
    }),
  ),
};
export default PopularActivity;
